import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bf3472a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "not-found is-flex is-justify-content-center is-align-items-center" }
const _hoisted_2 = { class: "page-container py-6" }
const _hoisted_3 = { class: "has-text-centered" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t("general.not-found")), 1)
    ])
  ]))
}